(function () {
  'use strict';

  var STORAGE_KEY = 'aa_wishlist_v1';
  var EVENT_NAME = 'aa:wishlist:change';

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (item) {
        return item && typeof item.handle === 'string';
      });
    } catch (e) {
      return [];
    }
  }

  function writeStore(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { items: items } }));
  }

  function isIn(handle) {
    if (!handle) return false;
    var items = readStore();
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) return true;
    }
    return false;
  }

  function add(item) {
    if (!item || !item.handle) return;
    var items = readStore();
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === item.handle) return;
    }
    items.unshift({
      handle: item.handle,
      title: item.title || '',
      url: item.url || ('/products/' + item.handle),
      image: item.image || '',
      price: item.price || '',
      vendor: item.vendor || '',
      addedAt: Date.now()
    });
    writeStore(items);
  }

  function remove(handle) {
    if (!handle) return;
    var items = readStore().filter(function (item) {
      return item.handle !== handle;
    });
    writeStore(items);
  }

  function toggle(item) {
    if (!item || !item.handle) return false;
    if (isIn(item.handle)) {
      remove(item.handle);
      return false;
    }
    add(item);
    return true;
  }

  function getAll() { return readStore(); }
  function getCount() { return readStore().length; }

  window.AAWishlist = {
    storageKey: STORAGE_KEY,
    eventName: EVENT_NAME,
    get: getAll,
    count: getCount,
    has: isIn,
    add: add,
    remove: remove,
    toggle: toggle
  };

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { items: readStore() } }));
    }
  });

  function refreshButtons() {
    var buttons = document.querySelectorAll('[data-aa-wishlist-button]');
    buttons.forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var active = isIn(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var labelAdd = btn.getAttribute('data-label-add');
      var labelRemove = btn.getAttribute('data-label-remove');
      if (labelAdd && labelRemove) {
        btn.setAttribute('aria-label', active ? labelRemove : labelAdd);
        var labelEl = btn.querySelector('.aa-wishlist-btn__label');
        if (labelEl) labelEl.textContent = active ? labelRemove : labelAdd;
      }
    });
  }

  function refreshCounts() {
    var count = getCount();
    document.querySelectorAll('[data-aa-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('hidden', count === 0);
    });
    document.querySelectorAll('[data-aa-wishlist-bubble]').forEach(function (el) {
      el.toggleAttribute('hidden', count === 0);
    });
  }

  function bindButton(btn) {
    if (btn.__aaWishlistBound) return;
    btn.__aaWishlistBound = true;
    btn.setAttribute('data-aa-wishlist-bound', '');
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      var item = {
        handle: handle,
        title: btn.getAttribute('data-title') || '',
        url: btn.getAttribute('data-url') || '',
        image: btn.getAttribute('data-image') || '',
        price: btn.getAttribute('data-price') || '',
        vendor: btn.getAttribute('data-vendor') || ''
      };
      var nowActive = toggle(item);
      btn.classList.add('is-bumping');
      setTimeout(function () { btn.classList.remove('is-bumping'); }, 420);
      if (nowActive) {
        showToast(item.title ? item.title + ' added to wishlist' : 'Added to wishlist');
      } else {
        showToast(item.title ? item.title + ' removed' : 'Removed from wishlist');
      }
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-aa-wishlist-button]').forEach(bindButton);
    refreshButtons();
    refreshCounts();
  }

  function showToast(message) {
    var toast = document.querySelector('.aa-wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'aa-wishlist-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast.__hideTimer);
    toast.__hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 1900);
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-aa-wishlist-grid]');
    if (!root) return;
    var emptyState = document.querySelector('[data-aa-wishlist-empty]');
    var countOut = document.querySelector('[data-aa-wishlist-page-count]');
    var items = getAll();
    if (countOut) countOut.textContent = items.length;
    if (!items.length) {
      root.innerHTML = '';
      if (emptyState) emptyState.removeAttribute('hidden');
      return;
    }
    if (emptyState) emptyState.setAttribute('hidden', '');
    root.innerHTML = items.map(function (item) {
      var safeTitle = escapeHTML(item.title || '');
      var safeVendor = escapeHTML(item.vendor || '');
      var safePrice = escapeHTML(item.price || '');
      var safeUrl = escapeHTML(item.url || '#');
      var img = item.image
        ? '<img loading="lazy" src="' + escapeHTML(item.image) + '" alt="' + safeTitle + '">'
        : '<div class="aa-wishlist-card__placeholder"></div>';
      return (
        '<article class="aa-wishlist-card" data-wishlist-card="' + escapeHTML(item.handle) + '">' +
          '<a class="aa-wishlist-card__media" href="' + safeUrl + '" aria-label="' + safeTitle + '">' +
            img +
          '</a>' +
          '<button type="button" class="aa-wishlist-card__remove" data-aa-remove="' + escapeHTML(item.handle) + '" aria-label="Remove ' + safeTitle + ' from wishlist">' +
            '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M1 1 L9 9 M9 1 L1 9" stroke="currentColor" stroke-width="1" fill="none" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<div class="aa-wishlist-card__body">' +
            (safeVendor ? '<div class="aa-wishlist-card__vendor">' + safeVendor + '</div>' : '') +
            '<h3 class="aa-wishlist-card__title"><a href="' + safeUrl + '">' + safeTitle + '</a></h3>' +
            (safePrice ? '<div class="aa-wishlist-card__price">' + safePrice + '</div>' : '') +
            '<a class="aa-wishlist-card__cta button button--tertiary" href="' + safeUrl + '"><span class="button-label">View product</span></a>' +
          '</div>' +
        '</article>'
      );
    }).join('');

    root.querySelectorAll('[data-aa-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        remove(btn.getAttribute('data-aa-remove'));
      });
    });
  }

  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function init() {
    bindAll();
    renderWishlistPage();
    window.addEventListener(EVENT_NAME, function () {
      refreshButtons();
      refreshCounts();
      renderWishlistPage();
    });
    var moScheduled = false;
    function hasNewWishlistButton(node) {
      if (!node || node.nodeType !== 1) return false;
      if (node.matches && node.matches('[data-aa-wishlist-button]:not([data-aa-wishlist-bound])')) return true;
      if (node.querySelector && node.querySelector('[data-aa-wishlist-button]:not([data-aa-wishlist-bound])')) return true;
      return false;
    }
    var mo = new MutationObserver(function (mutations) {
      if (moScheduled) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (hasNewWishlistButton(added[j])) {
            moScheduled = true;
            window.requestAnimationFrame(function () {
              moScheduled = false;
              bindAll();
            });
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
